define('shared/initializer/form/adapters/mixins/EtagTrackable',[
    '../../constants',
    'shared/lib/RSVP',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/page/eTag'
], 
function (
    constants, 
    RSVP, 
    FormDataDispatcher,
    getETag
) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doBeforeSubmit = function() {
        var me = this;

        return RSVP.resolve()
            .then(function(){
                var dispatcher = new FormDataDispatcher( me.$form );
                return dispatcher.dispatch(
                {
                    items: 
                    {
                        'session.etag':
                        {
                            sources: [{
                                retrieve: function() {
                                    return getETag();
                                },
                                allowUndefined: true
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: constants.FIELD.ETAG
                            },
                            {
                                type: 'form',
                                key: constants.FIELD.PURCHASEINFO_ETAG
                            }]
                        }
                    },
                    timeout: 1 * 1000
                });
            });
        
    };

    return Ctor;
});
